export const SET_STEAM_LIBRARY = 'frontend/user-traits/SET_STEAM_LIBRARY';

const initialState = [];

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_STEAM_LIBRARY:
      return action.payload;
    default:
      return state;
  }
}
